import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { defaultValues } from './model';
import { emailFormSchema } from './schema';

export function useFormDefinition(v = defaultValues) {
  return useForm({
    resolver: zodResolver(emailFormSchema),
    defaultValues: v,
  });
}

export type UseFormDef = ReturnType<typeof useFormDefinition>;
